module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  if(locals.isPrimary) { 
    ; __append(" <p class=\"bank_account_button\"></p> <p class=\"credit_card_button\"></p> ")
    ;  } else { 
    ; __append(" <div class=\"bank_account_button\"></div> <div class=\"credit_card_button\"></div> <p class=\"note\"> <strong>Add a Backup Card</strong><br> This will fund your account in case the primary payment method fails to charge or has an outstanding transfer.</p> <p class=\"note\"> <strong>Bank transfers take up to 5 business days to process</strong>, so it is recommended that bank account users register a backup card to ensure on-demand funding while transfers are processed. </p> ")
    ;  } 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/payment_method_type_selection.ejs
// module id = 862
// module chunks = 1